export function downloadBlob(blob: Blob, fileName: string): void {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  window.URL.revokeObjectURL(url);
}

export function createObjectUrl(blob: Blob): string {
  return window.URL.createObjectURL(blob);
}

export function revokeObjectUrl(url: string | null | undefined): void {
  if (url) {
    window.URL.revokeObjectURL(url);
  }
}

export function canPreviewMimeType(mimeType: string | null | undefined): boolean {
  if (!mimeType) return false;

  return mimeType === 'application/pdf' || mimeType.startsWith('image/');
}

export function getFileNameFromContentDisposition(contentDisposition: string | null): string {
  if (!contentDisposition) return 'downloaded-file';

  const match = /filename="?([^\"]+)"?/i.exec(contentDisposition);
  return match?.[1] ?? 'downloaded-file';
}
